import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import type { TripHistoryResponse } from "../../hooks/react-query/linehaul/useTripHistory";

dayjs.extend(utc);

// Comprehensive mock data for trip 10016841 with all features for testing
export const mockTripHistory: TripHistoryResponse = {
  originSic: {
    id: 103,
    code: "EWR",
    ownership: "V",
    lhRegionId: 3,
    timeZone: "America/New_York",
  },
  destinationSic: {
    id: 111,
    code: "DAL",
    ownership: "C",
    lhRegionId: 6,
    timeZone: "America/Chicago",
  },
  deadheadOriginSic: "OHN",
  deadheadDestinationSic: "ATL",
  stops: [],
  statusTripHistory: [
    {
      id: 101,
      tripStatus: "ENRT",
      locationDetails: {
        state: "NJ",
        city: "Test Location",
        zipCode: "07001",
        locationSic: "EWR",
      },
      createdBy: "TEST USER",
      createdById: "123",
      createdOn: dayjs.utc("2024-01-07T16:00:00"), // UTC time that displays as 11:00 AM EST (UTC-5)
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-23T17:04:00"), // UTC time that displays as 1:04 PM EDT (UTC-4)
      statusEndDateUtc: null, // Current status
      sameCity: true, // Has same city alert
      reason: null,
      reasonComment: "This is a test note", // Has note
    },
    {
      id: 102,
      tripStatus: "ENRT",
      locationDetails: {
        state: "NJ",
        city: "Newark",
        zipCode: "07001",
        locationSic: "EWR",
      },
      createdBy: "John Smith",
      createdOn: dayjs.utc("2025-09-23T13:30:00"),
      createdById: "123",
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-23T13:00:00"),
      statusEndDateUtc: dayjs.utc("2025-09-23T17:04:00"),
      sameCity: false,
      reason: null,
      reasonComment: null,
    },
    {
      id: 103,
      tripStatus: "ENRT",
      locationDetails: {
        state: "NJ",
        city: "Newark",
        zipCode: "07001",
        locationSic: "EWR",
      },
      createdBy: "Jane Doe",
      createdOn: dayjs.utc("2025-09-23T12:30:00"),
      createdById: "123",
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-23T12:00:00"),
      statusEndDateUtc: dayjs.utc("2025-09-23T13:00:00"),
      sameCity: false,
      reason: null,
      reasonComment: null,
    },
    {
      id: 104,
      tripStatus: "DLAY",
      locationDetails: {
        state: "NJ",
        city: "Newark",
        zipCode: "07001",
        locationSic: "EWR",
      },
      createdBy: "John Smith",
      createdOn: dayjs.utc("2025-09-22T19:30:00"),
      createdById: "123",
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-22T19:00:00"),
      statusEndDateUtc: dayjs.utc("2025-09-23T12:00:00"),
      sameCity: false,
      reason: "Weather",
      reasonComment: "Heavy rain delays",
    },
    {
      id: 105,
      tripStatus: "DLAY",
      locationDetails: {
        state: "NJ",
        city: "Newark",
        zipCode: "07001",
        locationSic: "EWR",
      },
      createdBy: "Admin User",
      createdById: "123",
      createdOn: dayjs.utc("2025-09-22T18:00:00"),
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-22T17:30:00"),
      statusEndDateUtc: dayjs.utc("2025-09-22T19:00:00"),
      sameCity: false,
      reason: null,
      reasonComment: null,
    },
    {
      id: 106,
      tripStatus: "ARIV",
      locationDetails: {
        state: "TX",
        city: "Dallas",
        zipCode: "75201",
        locationSic: "DAL",
      },
      createdBy: "Jane Doe",
      createdOn: dayjs.utc("2025-09-21T12:15:00"),
      createdById: "123",
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-21T12:00:00"),
      statusEndDateUtc: dayjs.utc("2025-09-22T17:30:00"),
      sameCity: false,
      reason: null,
      reasonComment: null,
    },
    {
      id: 107,
      tripStatus: "PLAN",
      locationDetails: {
        state: "TX",
        city: "Dallas",
        zipCode: "75201",
        locationSic: "DAL",
      },
      createdBy: "Planner User",
      createdOn: dayjs.utc("2025-09-20T14:00:00"),
      createdById: "123",
      modifiedBy: "",
      modifiedOn: null,
      statusUpdateTime: dayjs.utc("2025-09-20T13:30:00"),
      statusEndDateUtc: dayjs.utc("2025-09-21T12:00:00"),
      sameCity: false,
      reason: null,
      reasonComment: null,
    },
  ],
};
